import React, { useEffect, useState, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageDealers from '../manage-dealers';
import VIMSSFTPCreation from '../create-VimsSFTP';
import useStyles from './styles';


type AccordionItem = { title: string; open: boolean; component: FC<{}> };
type AccordionData = { title: string; data: AccordionItem[] }[];

const sections = [
    {
        title: '',
        data: [
            { title: 'New VIMS SFTP User Configuration', open: true, component: VIMSSFTPCreation },
            { title: 'Update VIMS SFTP User Configuration', open: false, component: ManageDealers },
        ],
    },
];

const VIMSSFTPConfig = () => {
    const classes = useStyles();

    const [accordionData, setAccordionData] = useState<AccordionData>(sections);
    const toggleOpen = (sectionIterator: number, componentIterator: number) => {
        const toggledAdminAccordion = [...accordionData];
        toggledAdminAccordion[sectionIterator].data[componentIterator].open = !accordionData[sectionIterator]
            .data[componentIterator].open;
        setAccordionData(toggledAdminAccordion);
    };

    return (
        <div className={classes.accordions}>
            {accordionData.map((section, sectionIterator) => (
                <>
                    <Box>
                        <Typography variant="h6">{section.title}</Typography>
                    </Box>
                    {section.data.map((componentContainer, componentIterator) => (
                        <Accordion
                            id={`${componentContainer.title}Panel`}
                            expanded={componentContainer.open}
                            onChange={() => toggleOpen(sectionIterator, componentIterator)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel-content"
                                id="panel-header"
                            >
                                <Typography variant="h5">{componentContainer.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {componentContainer.open && <componentContainer.component />}
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </>
            ))}
        </div>
    );
}
export default VIMSSFTPConfig;